import { render, staticRenderFns } from "./editImprest.vue?vue&type=template&id=83ce6fc2&scoped=true"
import script from "./editImprest.vue?vue&type=script&lang=js"
export * from "./editImprest.vue?vue&type=script&lang=js"
import style0 from "./editImprest.vue?vue&type=style&index=0&id=83ce6fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ce6fc2",
  null
  
)

export default component.exports